export const UPDATE_NAVIGATION_HISTORY =
  '@@NAVIGATION/UPDATE_NAVIGATION_HISTORY';
export const RESET_NAVIGATION_ACCOUNT = '@@NAVIGATION/RESET_NAVIGATION_ACCOUNT';
export const POP_NAVIGATION_ACCOUNT = '@@NAVIGATION/POP_NAVIGATION_ACCOUNT';
export const RESET_NAVIGATION_PAYMENTS = '@@NAVIGATION/RESET_NAVIGATION_PAYMENTS';

export default (state: any, action: any) => {
  switch (action.type) {
    case UPDATE_NAVIGATION_HISTORY:
      if (
        action.payload !==
        state.navigationHistory[state.navigationHistory.length - 1]
      ) {
        state.navigationHistory.push(action.payload);
      }
      return {
        ...state,
      };
    case RESET_NAVIGATION_ACCOUNT:
      return {
        ...state,
        navigationHistory: [
          {
            title: 'Inicio',
            url: '/dashboard',
          },
          {
            title: 'Cuenta',
            url: '/account',
          },
        ],
      };
      case RESET_NAVIGATION_PAYMENTS:
      return {
        ...state,
        navigationHistory: [
          {
            title: 'Inicio',
            url: '/dashboard',
          },
          {
            title: 'Cuenta',
            url: '/account',
          },
          {
            title: 'Mis pagos',
            url: '/payments'
          }
        ],
      };
    case POP_NAVIGATION_ACCOUNT:
      state.navigationHistory.pop();
      return {
        ...state,
        lastPath: action.payload,
      };
    default:
      return state;
  }
};
